<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <el-button v-show="hasAuthority('addIdentity')" type="primary" @click="event().showDialog('add')">新建身份</el-button>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      :config="config"
      :datasource="datasource"
      class="table"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-link
              v-show="hasAuthority('editIdentity')"
              type='primary'
              :underline="false"
              class="details"
              @click="event().showDialog('set', scope)">
              编辑</el-link>
            <el-link
              v-show="hasAuthority('deleteIdentity')"
              style="margin-left: 5px"
              type='primary'
              :underline="false"
              class="details"
              @click="event().deleteIdentify(scope)">
              删除</el-link>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
    <el-dialog
      width="800px"
      class="dialog"
      :show-close="false"
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="showDialog">
      <el-form
        label-width="80px">
        <el-form-item label="身份名称">
          <el-input
            v-model="editorBody.name"
            placeholder="请输入管理员姓名"
            type="text"/>
        </el-form-item>
        <div class="tree-box">
          <div class="left-title">
            管理模块
          </div>
          <div class="tree">
            <el-tree
              highlight-current
              :data="treeDate"
              node-key="uuid"
              ref="tree"
              :props="defaultProps"
              :default-checked-keys="permCheckedKeys"
              show-checkbox>
            </el-tree>
          </div>
        </div>
        <div class="industry-box">
          <div class="left-title">
            关联产业
          </div>
          <div class="right-check-box">
            <el-checkbox-group v-model="checkIndustryList">
              <el-checkbox v-for="item in industryList" :key="item.value" :label="item.value">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form>
      <div class="btn-box">
        <el-button type="primary" @click="event().save()">确定</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { deleteIdentify, getIdentifyList, getPermissionsList, addIdentify, setIdentify } from '@/api/authority'
import { getIndustrySelectList } from '@/api/industry'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        word: ''
      },
      editorBody: {
        industryUuidList: [],
        name: '', // 姓名
        permissionList: [], // 角色uuid
        uuid: '' // uuid(添加时不用传入)
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'name',
            label: '管理员身份',
            width: '400'
          },
          {
            prop: 'permText',
            label: '管理模块',
            width: '600'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      showDialog: false,
      title: '',
      treeDate: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      type: '',
      permCheckedKeys: [],
      checkIndustryList: [],
      industryList: []//产业数组
    }
  },
  async mounted() {
    await this.network().getIdentifyList()
    await this.network().getPermissionsList()
    await this.network().getIndustrySelectList()
  },
  methods: {
    event() {
      return {
        deleteIdentify: (scope) => {
          this.$confirm('是否删除管理员身份？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteIdentify(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        showDialog: (type, scope) => {
          if (type === 'set') {
            this.type = 'set'
            this.title = '编辑身份'
            this.checkIndustryList = scope.row.industryUuidList
            this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys([])
              this.handlerTree(scope.row.permissionList)
              this.editorBody = scope.row
            })
          } else if (type === 'add') {
            this.type = 'add'
            this.editorBody = {}
            this.title = '添加身份'
            this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys([])
            })
          }
          this.showDialog = true
        },
        save: () => {
          this.editorBody.permissionList = [
            ...this.$refs.tree.getCheckedKeys(),
            ...this.$refs.tree.getHalfCheckedKeys()
          ]
          this.editorBody.industryUuidList = this.checkIndustryList
          if (!this.handlerVarifyBody()) return
          this.type === 'set' ? this.network().setIdentify() : this.network().addIdentify()
        }
      }
    },
    network() {
      return {
        getIdentifyList: async() => {
          const { data } = await getIdentifyList(this.body)
          this.datasource.total = data.total
          const roles = data.list
          roles.forEach((item, index) => {
            roles[index].permText = []
            item.permissionList.forEach((item1, index1) => {
              roles[index].permText.push(item1.name)
            })
            roles[index].permText = roles[index].permText.join('/')
          })
          this.datasource.data = roles
        },
        deleteIdentify: async(uuid) => {
          await deleteIdentify(uuid)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.network().getIdentifyList()
          this.network().getPermissionsList()
        },
        getPermissionsList: async() => { // 获取全部权限
          const { data } = await getPermissionsList()
          this.treeDate = data.list
        },
        addIdentify: async() => {
          await addIdentify(this.editorBody)
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.showDialog = false
          this.network().getIdentifyList()
          this.network().getPermissionsList()
        },
        setIdentify: async() => {
          await setIdentify(this.editorBody)
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.showDialog = false
          this.network().getIdentifyList()
          this.network().getPermissionsList()
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
            console.log(this.industryList)
          })
        },
      }
    },
    handlerTree(row) { // 处理默认勾选
      const permIds = []
      row.forEach((item) => {
        if (item.children && item.children.length) {
          item.children.forEach((li) => {
            if (li.children && li.children.length) {
              li.children.forEach((l) => {
                permIds.push(l.uuid)
              })
            } else {
              permIds.push(li.uuid)
            }
          })
        } else {
          permIds.push(item.uuid)
        }
      })
      this.permCheckedKeys = permIds
    },
    handlerVarifyBody() {
      if (!this.editorBody.name) {
        this.$message({
          message: '请填写身份名称',
          type: 'warning'
        })
        return false
      }
      if (!this.editorBody.permissionList.length) {
        this.$message({
          message: '请选择管理模块',
          type: 'warning'
        })
        return false
      }
      if (!this.editorBody.industryUuidList.length) {
        this.$message({
          message: '请选择关联产业',
          type: 'warning'
        })
        return false
      }
      return true
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getIdentifyList()
      this.network().getPermissionsList()
    },
    handleClose(){
      this.showDialog = false
      this.checkIndustryList = []
    },
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
  min-width: 1280px !important;
  overflow-x: hidden !important;
  Nav{
    margin-bottom: 15px;
  }
  .el-dialog__wrapper{
    /deep/ .el-dialog{
      padding: 15px 15px;
      border-radius: 15px
    }
    /deep/ .el-dialog__title{
      font-weight: bold;
    }
    /deep/ .el-form-item{
      width: 85%;
      display: flex;
      /deep/ .el-form-item__label{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex: 1;
      }
      /deep/ .el-form-item__content{
        margin-left: 20px !important;
        flex: 4;
        input{
          padding: 25px 10px;
        }
      }
    }
    .btn-box{
      display: flex;
      justify-content: center;
    }

    .tree-box{
      margin: 60px 0;
      display: flex;
      .left-title{
        flex: 1;
      }
      .tree{
        flex: 4;
      }
    }

    .industry-box{
      display: flex;
      margin-bottom: 60px;
      .left-title{
        flex: 1;
      }
      .right-check-box{
        flex: 4;
        /deep/.el-checkbox-group{
          display: flex;
          flex-direction: column;
          /deep/.el-checkbox{
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}

/deep/ .table{
  /deep/ .el-table__body .el-table__row{
    height: 150px;
  }
}
</style>
